module.exports = __webpack_public_path__ + "static/shop2-080f841dbf191f8f6ab7e7e1040e1c6f.jpg";